import React, { useEffect } from "react";
import WorkersDetailsCard from "../components/workers/workers-details/workers-details-card/WorkersDetailsCard";
import {
  AppDispatch,
  dynamicSet,
  getChildOrganizationList,
  getChildOrganizationListRequest,
  getMyOrganization,
} from "@src/redux";
import { useDispatch, useSelector } from "react-redux";
import { Spin } from "antd";
import { useParams } from "react-router-dom";

const Workers: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams();
  const {
    result: childOrganizationResult,
    loading: childOrganizationLoading,
  } = useSelector(getChildOrganizationList);
  const { result: organization } = useSelector(getMyOrganization);

  useEffect(() => {
    dispatch(
      getChildOrganizationListRequest({
        filter: {
          parentOrganizationId: id || "",
        },
        pagination: { pageLimit: 10, pageNumber: 1 },
      })
    );
  }, [id]);
  
  useEffect(() => {
    dispatch(
      dynamicSet("get_organization_level", {
        organizationLevel: organization?.level?.name,
      })
    );
  }, []);

  return (
    <div className="worker-list-container">
      <Spin spinning={childOrganizationLoading}>
        {childOrganizationResult?.items?.map((worker: any, index) => (
          <WorkersDetailsCard key={index} worker={worker} />
        ))}
      </Spin>
    </div>
  );
};

export default Workers;
